import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScrBaseTabComponent } from 'src/app/components/base.component';
import { BillingOrder } from 'src/app/models/billingorder.model';
import { Lease } from 'src/app/models/lease.model';
import { Config, ConfigService } from 'src/app/services/config.service';
import { GetOrderResponse, ShortCodesService } from 'src/app/services/shortcodes.service';

@Component({
  templateUrl: './monthly-statement.component.html',
  styleUrls: ['./monthly-statement.component.scss']
})
export class MonthlyStatementComponent extends ScrBaseTabComponent implements OnInit {

  public orderId: number;
  public order?: BillingOrder;
  public hasDiscount = false;
  public config?: Config;

  constructor(
    private route: ActivatedRoute,
    private shortCodesService: ShortCodesService,
    private configService: ConfigService,
  ) {
    super();

    this.tt = 'Statement';
    this.routeElement = 'statement';

    this.orderId = this.route.snapshot.params.orderId;
  }

  override getObjectId(): string {
    return `${this.orderId}`;
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.params.subscribe({
      next: (params) => {
        this.log.trace('params are now ' + JSON.stringify(params));
        this.orderId = params.orderId;
        this.fetchOrderAndConfig();
      }
    }));
  }

  fetchOrderAndConfig(): void {
    this.observe2<GetOrderResponse, Config>(this.shortCodesService.getOrder(this.orderId), this.configService.getConfig(), (r1,r2) => {
      this.order = r1.order;
      this.config = r2;
      this.hasDiscount = (this.order.lines || this.order.leases).some(l => (l.discountAmount && l.discountAmount !== 0) || (l.discountList && l.discountList.length > 0));
      return false;
    });

  }

  jumpToCheckOrWire() {
    document.getElementById('check-or-wire')?.scrollIntoView();
  }

  joinedDiscounts(item: Lease): string {
    if (item.discountList) {
      return item.discountList.map(d => d.displayName).join(', ');
    }
    else {
      return '';
    }
  }

  printInvoice() {
    this.clearMessages();
    this.observeDownloadOrAny(this.shortCodesService.getStatementPdf(this.orderId), (data: Blob) => {
      const file = new Blob([data], { type: 'application/pdf' });
      const fileUrl = URL.createObjectURL(file);
      const pdf = window.open(fileUrl);
      pdf?.print();
    });
  }

  downloadPdf() {
    this.clearMessages();
    this.observeDownloadOrAny(this.shortCodesService.getStatementPdf(this.orderId), (data: Blob) => {
      const file = new Blob([data], { type: 'application/pdf' });
      const fileUrl = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = fileUrl;
      a.target = '_blank';
      a.download = `ShortCode_Statement_${this.orderId}.pdf`;
      document.body.appendChild(a);
      a.click();
    });
  }
}

